export const LocationModel = {
    id: 0, // number
    name: "", // string
};
